import { render, staticRenderFns } from "./EstimatesOldPage.vue?vue&type=template&id=3ef402e2&"
import script from "./EstimatesOldPage.vue?vue&type=script&lang=js&"
export * from "./EstimatesOldPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports